import * as React from 'react'
import * as _ from 'lodash'
import './TrunkCall.css'

import { NetworkUser } from 'golgi'
import { standardSCU } from '../util'
import StepProps from './StepProps'
import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';
import { NewDrag, NodeDrag } from 'src/view/drags';
import { DragSourceSpec, DragSourceConnector, DragSourceMonitor, DragSource, DropTargetConnector, DropTargetMonitor, DropTarget, DropTargetSpec } from 'react-dnd';
import { Box, makeBox, setVars, parseConstraintTemplate as kfParse, boxContains, tree } from 'kiwifruit';
import { KiwifruitUser, propsFor, styleFor } from 'kiwifruit-react';
import classNames from 'classnames'

import * as actions from '../actions'
import { arrowSize } from 'src/view/Call';
import { referredOrOwnNodeId } from 'src/model/nodeInfo';
import { canDragFromStackIntoStack, Stack } from 'src/types/stack';


interface TrunkCallProps {
  nodeId: Model.NodeId,
  graphC: Cursor<Model.Graph>,
  blockC: Cursor<Model.Block>,
  stack: Stack,

  graphBox: Box,
  rootBox: Box,
}

class TrunkCall extends React.Component<TrunkCallProps & ReturnType<typeof dropCollect>> {
  render() {
    return <KiwifruitUser render={({ getVariable, addConstraint, id }) => {
      const { connectDropTarget, isOver, canDrop, graphBox, rootBox } = this.props

      if (!canDrop) { return null }

      const comboBox = makeBox(id + '-combo', addConstraint)

      addConstraint(...setVars(comboBox, {width: 30, height: 30}))
      addConstraint(kfParse`${comboBox.right} == ${rootBox.right}`)
      addConstraint(kfParse`${comboBox.top} == ${rootBox.bottom} + 20`)
      addConstraint(kfParse`${comboBox.bottom} + 20 <= ${graphBox.bottom}`)

      const arrowBox = makeBox(id + '-arrow', addConstraint)
      addConstraint(...
        tree.row({box: graphBox, spacing: 20},
          rootBox,
          arrowBox
        )
      )
      addConstraint(kfParse`${arrowBox.width} == 100`)
      addConstraint(kfParse`${arrowBox.top} + ${arrowSize} == ${rootBox.vMid}`)
      addConstraint(kfParse`${arrowBox.bottom} - ${arrowSize} >= ${rootBox.vMid}`)
      addConstraint(kfParse`${arrowBox.bottom} >= ${comboBox.vMid} + 5`)

      return <div className="TrunkCall">
        {connectDropTarget(
          <div 
            className={classNames({
              // intentional hack: re-use these classes
              "NewInputDropSite": true,
              "NewInputDropSite-can-drop": canDrop,
              "NewInputDropSite-is-over": isOver
            })}
            style={{
              position: 'absolute',
              left: getVariable(comboBox.left),
              top: getVariable(comboBox.top),
              width: getVariable(comboBox.width)}}
          />
        )}
        <svg className="TrunkCall-arrow" {...propsFor.svg(getVariable, arrowBox)} style={{...styleFor.svg(getVariable, arrowBox)}}>
          <line x1={getVariable(arrowBox.left)}              y1={getVariable(rootBox.vMid)}
                x2={getVariable(arrowBox.right)}             y2={getVariable(rootBox.vMid)} />
          <line x1={getVariable(arrowBox.right) - arrowSize} y1={getVariable(rootBox.vMid) - arrowSize}
                x2={getVariable(arrowBox.right)}             y2={getVariable(rootBox.vMid)} />
          <line x1={getVariable(arrowBox.right) - arrowSize} y1={getVariable(rootBox.vMid) + arrowSize}
                x2={getVariable(arrowBox.right)}             y2={getVariable(rootBox.vMid)} />
          <line x1={getVariable(arrowBox.left)}              y1={getVariable(comboBox.vMid)}
                x2={getVariable(arrowBox.left) + 15}         y2={getVariable(comboBox.vMid)} />
          <line x1={getVariable(arrowBox.left) + 15}         y1={getVariable(comboBox.vMid)}
                x2={getVariable(arrowBox.left) + 30}         y2={getVariable(rootBox.vMid)} />
        </svg>
      </div>
    }} />
  }
}

const dropSpec: DropTargetSpec<TrunkCallProps> = {
  drop(props, monitor) { actions.act(() => {
    switch (monitor.getItemType()) {
    case 'node':
      const nodeDrag = monitor.getItem() as NodeDrag
      switch (nodeDrag.type) {
        case 'move-subtree': {
          actions.moveSubtree(nodeDrag.blockC, nodeDrag.nodeId, props.graphC)
          actions.addCombiningCodeCallRaw(
            props.nodeId, nodeDrag.nodeId,
            props.graphC, props.blockC)
          break }
        case 'copy-reference': {
          const newRefNodeId = actions.addReferenceNodeToGraph(referredOrOwnNodeId(nodeDrag.blockC, nodeDrag.nodeId), props.graphC, props.blockC)
          actions.addCombiningCodeCallRaw(
            props.nodeId, newRefNodeId,
            props.graphC, props.blockC)
          break }
        default:
          throw new Error(`tried to drop unknown cell-type ${nodeDrag.type} on StepSpacer`)
      }
      break
    case 'new':
      const newDrag = monitor.getItem() as NewDrag
      switch (newDrag.type) {
        case 'node':
          const newEmptyNodeId = actions.addEmptyCodeCall(props.graphC)
          actions.addCombiningCodeCallRaw(
            props.nodeId, newEmptyNodeId,
            props.graphC, props.blockC)
          break
        default:
          throw new Error(`some weird kinda newDrag: ${newDrag.type}`)
      }
      break
    }
  })},

  canDrop(props, monitor) {
    switch (monitor.getItemType()) {
      case 'node':
        const nodeDrag = monitor.getItem() as NodeDrag
        return canDragFromStackIntoStack(nodeDrag.stack, props.stack) && nodeDrag.nodeId !== props.nodeId
      case 'new':
        const newDrag = monitor.getItem() as NewDrag
        return newDrag.type === 'node'
    }
    return true
  }
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

export default DropTarget(["new", "node"], dropSpec, dropCollect, {arePropsEqual: () => false})(TrunkCall)



// WEBPACK FOOTER //
// ./src/view/TrunkCall.tsx